export default __webpack_public_path__ + "static/media/theshop.26ad9e57.jpg";